import { render, staticRenderFns } from "./MatchInfoEdit.vue?vue&type=template&id=1ba6882e&"
import script from "./MatchInfoEdit.vue?vue&type=script&lang=js&"
export * from "./MatchInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports